export function MissingComponent() {
    return (
        <div data-testid="missingComponentSection" className="flex w-full p-10">
            <p className="mx-auto">This component is not defined or you do not have access to it.</p>
        </div>
    );
}
